import styled from 'styled-components';

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
`;

export const ModalContainer = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark' ? '#1E293B' : '#ffffff'};
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 600px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  padding: 24px 8px 24px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
`;

export const ModalTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  padding: 0 16px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#0F172A')};
`;

export const SearchBox = styled.div`
  position: relative;
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => (props.theme.name === 'dark' ? '#64748B' : '#94A3B8')};
  display: flex;
  align-items: center;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 44px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(0,0,0,0.05)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.15)'};
  border-radius: 8px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#0F172A')};
  font-size: 14px;
  transition: all 0.2s;

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#64748B' : '#94A3B8')};
  }

  &:focus {
    outline: none;
    border-color: #fa4616;
    box-shadow: 0 0 0 3px rgba(250, 70, 22, 0.1);
  }
`;

export const EventsList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  min-height: 350px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.2)'
        : 'rgba(0,0,0,0.2)'};
  }
`;

export const MonthGroup = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MonthLabel = styled.div`
  color: #fa4616;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 12px;
  padding: 0 8px;
`;

export const EventItem = styled.div`
  padding: 16px;
  margin-bottom: 8px;
  background: ${(props) =>
    props.selected
      ? 'rgba(250, 70, 22, 0.2)'
      : props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.03)'
      : 'rgba(0,0,0,0.03)'};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid ${(props) => (props.selected ? '#FA4616' : 'transparent')};

  &:hover {
    background: ${(props) =>
      props.selected ? 'rgba(250, 70, 22, 0.2)' : 'rgba(250, 70, 22, 0.1)'};
    border-color: ${(props) =>
      props.selected ? '#FA4616' : 'rgba(250, 70, 22, 0.3)'};
  }
`;

export const EventName = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#0F172A')};
`;

export const EventDate = styled.div`
  color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748B')};
  font-size: 13px;
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.02)'
      : 'rgba(0,0,0,0.02)'};
`;

export const Button = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  ${(props) =>
    props.primary
      ? `
    background: #FA4616;
    color: #ffffff;
    border: none;
    
    &:hover:not(:disabled) {
      background: #E03E0C;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `
      : `
    background: transparent;
    color: ${props.theme.name === 'dark' ? '#94A3B8' : '#64748B'};
    border: 1px solid ${
      props.theme.name === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'
    };
    
    &:hover {
      background: ${
        props.theme.name === 'dark'
          ? 'rgba(255,255,255,0.05)'
          : 'rgba(0,0,0,0.05)'
      };
      border-color: ${
        props.theme.name === 'dark'
          ? 'rgba(255,255,255,0.2)'
          : 'rgba(0,0,0,0.2)'
      };
    }
  `}
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748B')};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748B')};
  text-align: center;

  div:first-child {
    font-size: 16px;
    margin-bottom: 8px;
  }

  div:last-child {
    font-size: 14px;
    opacity: 0.7;
  }
`;
